import {abilityFeature} from '../abilityFeature';
import {selectIsUserComponentFocused} from '@packages/utilities/platform-selectors';

export const isUserComponentFocused = abilityFeature({
  key: 'isUserComponentFocused',
  isValid: function isUserComponentFocusedValid(state, expected) {
    const isFocused = selectIsUserComponentFocused(state);
    return isFocused === expected;
  },
});
